import React, { Component } from 'react'
import { connect } from 'react-redux'

import AuthUIS from '../components/auth-uis/auth'
import { setInputToken, setInputPass, auth} from '../store/action/authUIS.action'



//делаем враппер для компонента с прокидыванием необходимых пропсов
class AuthUisContainer extends Component {
    render(){
        return(
             this.props.store.user_is_auth ? null : <AuthUIS {...this.props} /> 
        )
    }
}
//прокидываем данные из стор в пропс
const mapStateToProps = store => {
    return {
        store: store.authUIS
    }
}
//прокидываем диспатч из стор в пропс
const mapDispatchToProps = dispatch => {
    return {
        actionForm: {
            setInputToken: text => dispatch(setInputToken(text)),
            auth: (token) => dispatch(auth(token)),
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthUisContainer)